import { render, staticRenderFns } from "./RoleModalForm.vue?vue&type=template&id=1dd3500f"
import script from "./RoleModalForm.vue?vue&type=script&lang=js"
export * from "./RoleModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports